import templateUrl from './project-favourite-button.html'
import './project-favourite-button.scss'

const ProjectFavouriteButtonComponent = {
  bindings: {
    project: '<',
    onChange: '&?'
  },
  templateUrl,
  controller: class ProjectFavouriteButtonComponent {
    constructor (ProjectService, EventEmitter, ModalService) {
      'ngInject'
      this._identify = 'ProjectFavouriteButtonComponent'
      this.ProjectService = ProjectService
      this.EventEmitter = EventEmitter
      this.ModalService = ModalService

      this.isProcessing = false
    }

    $onInit () {

    }

    get tooltipText () {
      this.addText = 'Add to favourites'
      this.removeText = 'Remove from favourites'

      return this.project.favoredByCurrentUser ? this.removeText : this.addText
    }

    toggleFavourite ($event) {
      $event.preventDefault()
      $event.stopPropagation()
      console.log('[ProjectFavouriteButtonComponent] > toggleFavourite')

      if (this.isProcessing) {
        return
      }
      this.isProcessing = true

      const isFavourite = !this.project.favoredByCurrentUser
      const request = isFavourite
        ? this.ProjectService.favouriteProject(this.project.id)
        : this.ProjectService.unfavouriteProject(this.project.id)

      request
        .then(response => {
          // Only flip local state once BE confirmed the change (KB-8719: BE now rejects non-participant tasks)
          this.project.favoredByCurrentUser = isFavourite

          if (this.onChange) {
            this.onChange(this.EventEmitter({ projectId: this.project.id, isFavourite: this.project.favoredByCurrentUser }))
          }
        })
        .catch(err => {
          console.log('[ProjectFavouriteButtonComponent] > toggleFavourite > error', err)
          this.ModalService.open(this.ModalService.generateConfig('default', {
            title: isFavourite ? 'Could not add to favourites' : 'Could not remove from favourites',
            // Static text only: modal bodies are compiled as templates, never interpolate the server response here (KB-8720)
            // BE 403 body: { error: 'forbidden', reason: 'not_authorized', message: 'Not authorized.' }
            body: err && err.status === 403 && err.data && err.data.reason === 'not_authorized'
              ? '<p>You can only favourite projects you are invited to or working on.</p>'
              : '<p>Something went wrong. Please try again or contact Codeable support.</p>',
            closeOnBackdrop: true,
            resolveButton: { label: 'OK', class: 'button-primary' }
          }))
        })
        .finally(() => {
          this.isProcessing = false
        })
    }
  }
}

export default ProjectFavouriteButtonComponent
